import { render } from "./view.html?vue&type=template&id=a80aadde&ts=true&external"
import script from "./view.ts?vue&type=script&lang=ts&external"
export * from "./view.ts?vue&type=script&lang=ts&external"

import "./view.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__